import React, { useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { ImageGalleryDialog } from './ImageGalleryDialog';

export type ImageGalleryProps = {
  applicationIds: number[];
  label: string;
  noItemsMessage: string;
};

const ImageGallery: React.FC<ImageGalleryProps> = ({ applicationIds, label, noItemsMessage }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const closeDialog = () => {
    requestAnimationFrame(() => buttonRef.current?.focus());
    setIsDialogOpen(false);
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="btn btn-outline-primary btn-sm"
        onClick={() => setIsDialogOpen(true)}
      >
        <i className="fas fa-images me-1"></i>
        {label}
      </button>

      {isDialogOpen && (
        <ImageGalleryDialog
          applicationIds={applicationIds}
          label={label}
          noItemsMessage={noItemsMessage}
          onClose={closeDialog}
        />
      )}
    </>
  );
};

export default function registerImageGallery(options: {
  container: HTMLElement,
  applicationIds: number[],
  label: string,
  noItemsMessage: string
}) {
  if (options.container) {
    createRoot(options.container).render(
      <ImageGallery applicationIds={options.applicationIds} label={options.label} noItemsMessage={options.noItemsMessage} />
    );
  }
}
